import { Box, Avatar, Typography, makeStyles, Link } from "@material-ui/core";
import * as React from "react";

import { PropertyTypeTags } from "@/components/agent/PlannerTags";
import theme from "@/theme";

import NoImagePath from "@assets/image/NoImage.svg";

const useStyles = makeStyles(() => ({
  profileImage: {
    width: 113,
    height: 113,
  },
  companyImage: {
    height: 24,
  },
  badge: {
    backgroundColor: theme.palette.yellow[600],
    padding: "2px 8px",
    width: "fit-content",
    color: theme.palette.background.paper,
  },
  summaryWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "flex-start",
  },
  supportTypeRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexWrap: "wrap",
  },
  supportTypeLabel: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.5,
  },
}));

interface props {
  profileImagePath: string;
  companyImagePath: string;
  companyName: string;
  companyHomePageUrl?: string;
  representativeName: string;
  isNew?: boolean;
  supportedPropertyTypes?: string[];
}

export const AgentProfile: React.FC<props> = ({
  profileImagePath,
  companyImagePath,
  companyName,
  companyHomePageUrl,
  representativeName,
  isNew,
  supportedPropertyTypes = [],
}) => {
  const classes = useStyles();
  return (
    <Box mt={1} display="flex" alignItems="center">
      <Avatar src={profileImagePath ? profileImagePath : NoImagePath} alt="profile" className={classes.profileImage} />
      <Box ml={2} className={classes.summaryWrapper}>
        {isNew && (
          <Box className={classes.badge}>
            <Typography variant="h5">NEW!</Typography>
          </Box>
        )}
        <img src={companyImagePath ? companyImagePath : NoImagePath} className={classes.companyImage} alt="company" />
        <Box>
          <Typography variant="h4">{representativeName}</Typography>
          <Typography variant="body1">{companyName}</Typography>

          {companyHomePageUrl && (
            <Box mt={1}>
              <Link href={companyHomePageUrl} underline="always">
                会社HP
              </Link>
            </Box>
          )}
          {supportedPropertyTypes.length > 0 && (
            <Box mt={1} className={classes.supportTypeRow}>
              <Typography className={classes.supportTypeLabel}>対応可能種別：</Typography>
              <PropertyTypeTags labels={supportedPropertyTypes} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
